export * from './FoodDrinkCupStrawIcon';
export * from './FoodDrinkCupStrawIcon16Light';
export * from './FoodDrinkCupStrawIcon16Regular';
export * from './FoodDrinkCupStrawIcon16Solid';
export * from './FoodDrinkCupStrawIcon20Light';
export * from './FoodDrinkCupStrawIcon20Regular';
export * from './FoodDrinkCupStrawIcon20Solid';
export * from './FoodDrinkCupStrawIcon24Regular';
export * from './FoodDrinkCupStrawIcon24Solid';
export * from './FoodDrinkCupStrawIcon32Regular';
export * from './FoodDrinkCupStrawIcon64Regular';
